"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAgentsAreaInsightsStatsAgentsAreaInsightsGetRequest$ = exports.GetAgentsAreaInsightsStatsAgentsAreaInsightsGetRequest$outboundSchema = exports.GetAgentsAreaInsightsStatsAgentsAreaInsightsGetRequest$inboundSchema = exports.GetAgentsAreaInsightsStatsAgentsAreaInsightsGetSecurity$ = exports.GetAgentsAreaInsightsStatsAgentsAreaInsightsGetSecurity$outboundSchema = exports.GetAgentsAreaInsightsStatsAgentsAreaInsightsGetSecurity$inboundSchema = void 0;
exports.getAgentsAreaInsightsStatsAgentsAreaInsightsGetSecurityToJSON = getAgentsAreaInsightsStatsAgentsAreaInsightsGetSecurityToJSON;
exports.getAgentsAreaInsightsStatsAgentsAreaInsightsGetSecurityFromJSON = getAgentsAreaInsightsStatsAgentsAreaInsightsGetSecurityFromJSON;
exports.getAgentsAreaInsightsStatsAgentsAreaInsightsGetRequestToJSON = getAgentsAreaInsightsStatsAgentsAreaInsightsGetRequestToJSON;
exports.getAgentsAreaInsightsStatsAgentsAreaInsightsGetRequestFromJSON = getAgentsAreaInsightsStatsAgentsAreaInsightsGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const shared = __importStar(require("../shared/index.js"));
/** @internal */
exports.GetAgentsAreaInsightsStatsAgentsAreaInsightsGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetAgentsAreaInsightsStatsAgentsAreaInsightsGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetAgentsAreaInsightsStatsAgentsAreaInsightsGetSecurity$;
(function (GetAgentsAreaInsightsStatsAgentsAreaInsightsGetSecurity$) {
    /** @deprecated use `GetAgentsAreaInsightsStatsAgentsAreaInsightsGetSecurity$inboundSchema` instead. */
    GetAgentsAreaInsightsStatsAgentsAreaInsightsGetSecurity$.inboundSchema = exports.GetAgentsAreaInsightsStatsAgentsAreaInsightsGetSecurity$inboundSchema;
    /** @deprecated use `GetAgentsAreaInsightsStatsAgentsAreaInsightsGetSecurity$outboundSchema` instead. */
    GetAgentsAreaInsightsStatsAgentsAreaInsightsGetSecurity$.outboundSchema = exports.GetAgentsAreaInsightsStatsAgentsAreaInsightsGetSecurity$outboundSchema;
})(GetAgentsAreaInsightsStatsAgentsAreaInsightsGetSecurity$ || (exports.GetAgentsAreaInsightsStatsAgentsAreaInsightsGetSecurity$ = GetAgentsAreaInsightsStatsAgentsAreaInsightsGetSecurity$ = {}));
function getAgentsAreaInsightsStatsAgentsAreaInsightsGetSecurityToJSON(getAgentsAreaInsightsStatsAgentsAreaInsightsGetSecurity) {
    return JSON.stringify(exports.GetAgentsAreaInsightsStatsAgentsAreaInsightsGetSecurity$outboundSchema
        .parse(getAgentsAreaInsightsStatsAgentsAreaInsightsGetSecurity));
}
function getAgentsAreaInsightsStatsAgentsAreaInsightsGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetAgentsAreaInsightsStatsAgentsAreaInsightsGetSecurity$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetAgentsAreaInsightsStatsAgentsAreaInsightsGetSecurity' from JSON`);
}
/** @internal */
exports.GetAgentsAreaInsightsStatsAgentsAreaInsightsGetRequest$inboundSchema = z.object({
    "filter[end_date]": z.string().optional(),
    "filter[listing_type]": shared.ListingType$inboundSchema.optional(),
    "filter[max_estimated_value]": z.number().int().optional(),
    "filter[max_estimated_value_rounded]": z.number().int().optional(),
    "filter[max_price]": z.number().int().optional(),
    "filter[min_estimated_value]": z.number().int().optional(),
    "filter[min_estimated_value_rounded]": z.number().int().optional(),
    "filter[min_price]": z.number().int().optional(),
    "filter[property_type]": z.array(shared.PropertyType$inboundSchema)
        .optional(),
    "filter[start_date]": z.string().optional(),
    outcode: z.array(z.string()).optional(),
    point: z.array(z.string()).optional(),
    postcode: z.string().optional(),
    radius: z.number().int().optional(),
    sector: z.array(z.string()).optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "filter[end_date]": "filterEndDate",
        "filter[listing_type]": "filterListingType",
        "filter[max_estimated_value]": "filterMaxEstimatedValue",
        "filter[max_estimated_value_rounded]": "filterMaxEstimatedValueRounded",
        "filter[max_price]": "filterMaxPrice",
        "filter[min_estimated_value]": "filterMinEstimatedValue",
        "filter[min_estimated_value_rounded]": "filterMinEstimatedValueRounded",
        "filter[min_price]": "filterMinPrice",
        "filter[property_type]": "filterPropertyType",
        "filter[start_date]": "filterStartDate",
    });
});
/** @internal */
exports.GetAgentsAreaInsightsStatsAgentsAreaInsightsGetRequest$outboundSchema = z.object({
    filterEndDate: z.string().optional(),
    filterListingType: shared.ListingType$outboundSchema.optional(),
    filterMaxEstimatedValue: z.number().int().optional(),
    filterMaxEstimatedValueRounded: z.number().int().optional(),
    filterMaxPrice: z.number().int().optional(),
    filterMinEstimatedValue: z.number().int().optional(),
    filterMinEstimatedValueRounded: z.number().int().optional(),
    filterMinPrice: z.number().int().optional(),
    filterPropertyType: z.array(shared.PropertyType$outboundSchema).optional(),
    filterStartDate: z.string().optional(),
    outcode: z.array(z.string()).optional(),
    point: z.array(z.string()).optional(),
    postcode: z.string().optional(),
    radius: z.number().int().optional(),
    sector: z.array(z.string()).optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        filterEndDate: "filter[end_date]",
        filterListingType: "filter[listing_type]",
        filterMaxEstimatedValue: "filter[max_estimated_value]",
        filterMaxEstimatedValueRounded: "filter[max_estimated_value_rounded]",
        filterMaxPrice: "filter[max_price]",
        filterMinEstimatedValue: "filter[min_estimated_value]",
        filterMinEstimatedValueRounded: "filter[min_estimated_value_rounded]",
        filterMinPrice: "filter[min_price]",
        filterPropertyType: "filter[property_type]",
        filterStartDate: "filter[start_date]",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetAgentsAreaInsightsStatsAgentsAreaInsightsGetRequest$;
(function (GetAgentsAreaInsightsStatsAgentsAreaInsightsGetRequest$) {
    /** @deprecated use `GetAgentsAreaInsightsStatsAgentsAreaInsightsGetRequest$inboundSchema` instead. */
    GetAgentsAreaInsightsStatsAgentsAreaInsightsGetRequest$.inboundSchema = exports.GetAgentsAreaInsightsStatsAgentsAreaInsightsGetRequest$inboundSchema;
    /** @deprecated use `GetAgentsAreaInsightsStatsAgentsAreaInsightsGetRequest$outboundSchema` instead. */
    GetAgentsAreaInsightsStatsAgentsAreaInsightsGetRequest$.outboundSchema = exports.GetAgentsAreaInsightsStatsAgentsAreaInsightsGetRequest$outboundSchema;
})(GetAgentsAreaInsightsStatsAgentsAreaInsightsGetRequest$ || (exports.GetAgentsAreaInsightsStatsAgentsAreaInsightsGetRequest$ = GetAgentsAreaInsightsStatsAgentsAreaInsightsGetRequest$ = {}));
function getAgentsAreaInsightsStatsAgentsAreaInsightsGetRequestToJSON(getAgentsAreaInsightsStatsAgentsAreaInsightsGetRequest) {
    return JSON.stringify(exports.GetAgentsAreaInsightsStatsAgentsAreaInsightsGetRequest$outboundSchema.parse(getAgentsAreaInsightsStatsAgentsAreaInsightsGetRequest));
}
function getAgentsAreaInsightsStatsAgentsAreaInsightsGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetAgentsAreaInsightsStatsAgentsAreaInsightsGetRequest$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetAgentsAreaInsightsStatsAgentsAreaInsightsGetRequest' from JSON`);
}
//# sourceMappingURL=getagentsareainsightsstatsagentsareainsightsget.js.map